"use client";

import Image from "next/image";

import cn from "classnames";
import { Image as ImageType } from "sanity";

import { urlFor } from "@/sanity/utils";

import type { ProductQueryOptionValue } from "../productOptionsProduct/productOptionsProduct.component";

export const ProductOptionsColorValue = ({
  id,
  title,
  image,
  product,
  selected,
  onChange,
}: ProductOptionsColorValueProps) => {
  const url = image?.[0]
    ? urlFor(image[0])?.width(38)?.height(38)?.url()
    : null;

  return (
    <li data-testid="product-options-color-option" className="list-none">
      <label htmlFor={id} className={cn("flex cursor-pointer flex-row gap-2")}>
        <span className="sr-only">{title}</span>
        {url ? (
          <Image
            src={url}
            alt={product?.name ?? title ?? ""}
            width={38}
            height={38}
            className={cn("rounded-full border-2 p-0.5", {
              "border-secondary": selected,
              "border-transparent": !selected,
            })}
          />
        ) : null}
        <input
          required
          data-testid="product-options-color-option-input"
          id={id}
          type="radio"
          name="variantId"
          className="hidden"
          value={product?.id ?? id}
          checked={selected}
          onChange={() => id && onChange?.(id)}
        />
      </label>
    </li>
  );
};

export type ProductOptionsColorValueProps = {
  id?: string;
  title?: string | null;
  description?: string | null;
  image?: ImageType[] | null;
  product?: ProductQueryOptionValue["product"];
  selected?: boolean;
  fieldsetName: string;
  onChange?: (id: string) => void;
};
